import { usePersonalDetails } from '@chilipiper/workspace-queries/src/api-queries/personal-details'
import { NON_IC_ROLES } from '@chilipiper/onboarding'
import { useFireSessionContext } from '@chilipiper/fire-session'
import { useTenant } from '../api/workspace'
import { useTenantDetails } from '../api/tenant'
import { useAdminCenterUrl } from './useAdminCenterUrl'

export const useShouldNudgeToClaimAdminCenter = () => {
  const { data: tenantData } = useTenant()
  const { userId } = useFireSessionContext()
  const { data: tenantDetails } = useTenantDetails()
  const { data: personalDetails } = usePersonalDetails(userId)
  const adminCenterUrl = useAdminCenterUrl()

  const isOrgTenant = tenantDetails?.tenantInfo.type === 'Organization'
  const isTenantUnclaimed = tenantData?.claimStatus === 'Unclaimed'
  const isNonIndividualContributor =
    personalDetails && NON_IC_ROLES.includes(personalDetails?.jobTitle ?? '')
  const shouldNudgeToClaimAdminCenter = Boolean(
    isNonIndividualContributor && isOrgTenant && isTenantUnclaimed
  )

  return {
    shouldNudgeToClaimAdminCenter,
    adminCenterUrl: adminCenterUrl,
  }
}
